import React from 'react';
import styled from 'styled-components';
import { assetTheme as t } from './assetTheme';

// Rendered inside the dark hub top bar (GoHubTopNav appLogo slot)
const Title = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -.01em;
  white-space: nowrap;
  font-family: ${t.fontFamily};
`

export default () => {
  return (
    <Title>{'Asset Manager'}</Title>
  )
}
